// Tag List for Document Interpolation
// Field Name, Tag, Example


const tags = [

    ['Legal Signature', '{%image}', '--This tag is for the signature line only--'],
    ['Property Name', '{property_name}', 'Lago Club Apartments'],
    ['Legal Name', '{legal_name}', 'Village Shopping Center Trust, LLC'],
    ['Lookup Code', '{lookup_code}', '020'],
    ['Unit #', '{bldg_unit}', '45-104'],
    ['Student ID', '{student_id}', 'g-1234456'],
    ['Resident Name', '{resident_name}', 'Rosales, Odalis'],
    ['Street Line 1', '{street_line1}', '12345 SW 18th St. # 45-0104'],
    ['Street Line 2', '{street_line2}', ''],
    ['Street Line 3', '{street_line3}', ''],
    ['City', '{city}', 'Miami'],
    ['State', '{state_code}', 'FL'],
    ['Zip Code', '{postal_code}', '33175'],
    ['Country', '{country_code}', 'US'],
    ['Email Address', '{email_address}', 'odalys2261@att.net'],
    ['Phone Number', '{phone_number}', '(786) 804-2707'],
    ['Lease Status', '{lease_status}', 'Current'],
    ['Unpaid Rent', '{unpaid_rent}', '566.85'],
    ['Unpaid Others', '{unpaid_others}', '0'],
    ['Unpaid Deposits', '{unpaid_deposits}', '0'],
    ['Total Current Due', '{total_current_due}', '566.85'],
    ['Total Past Due', '{total_past_due}', '0'],
    ['Unallocated Payments & Credits', '{unallocated_payments_and_credits}', '0'],
    ['Total Delinquent', '{total_delinquent}', '566.85'],
    ['Notes', '{notes}', 'Blah'],
    ['Move-In Date', '{move_in_date}', '02/06/2008'],
    ['Lease Start Date', '{lease_start_date}', '01/01/2020'],
    ['Lease End Date', '{lease_end_date}', '01/31/2021'],
    ['Move Out Date', '{move_out_date}', '01/31/2021'],
    ['Termination Start Date', '{termination_start_date}', '01/31/2021'],
    ['Eviction Completed Date', '{eviction_completed_on}', '01/31/2021'],
    ['Payment Status', '{payment_status}', 'Allow All Payment Types'],
    ['Lease Sub Status', '{lease_sub_status}', 'Eviction'],
    ['Active Repayment Agreement', '{active_repayment_agreement}', 'No'],
    ['Scheduled Rent', '{scheduled_rent}', '1575'],
    ['Other Scheduled Rent', '{other_scheduled_rent}', null],
    ['Occupancy Type', '{occupancy_type}', 'Conventional'],
    ['Held By', '{held_by}', 'Held By'],
    ['File Date', '{file_date}', '2001-01-01'],
    ['Hold Date', '{hold_date}', '2001-01-01'],
    ['Judgement', '{judgement}', '2001-01-01'],
    ['Admin Notes', '{admin_notes}', 'Admin Notes'],
    ['Case #', '{case_number}', '123456'],
    ['Default Date', '{default_date}', '2001-01-01'],
    ['Manager Notes', '{manager_notes}', 'Manager Notes'],
    ['Court Registry', '{court_registry}', '123456'],
    ['Special Status', '{special_status}', 'Section 8'],
    ['Summons Served', '{summons_served}', '2001-01-01'],
    ['Motion To Strike', '{motion_to_strike}', '2001-01-01'],
    ['3-Day Served', '{three_day_served}', '2001-01-01'],
    ['Writ Of Possession', '{writ_of_possession}', '2001-01-01'],
    ['24-Hour Notice', '{twentyfour_hour_notice}', '2001-01-01'],
    ['Lawyer Name', '{lawyer_name}', 'Mr. Law Pants'],
    ['Lawyer Address', '{lawyer_address}', '1234 Law Street'],
    ['Lawyer Phone Number', '{lawyer_phone_number}', '305-305-3055'],
    ['Lawyer Bar Number', '{lawyer_bar_number}', 'B-13442'],
    ['Notary Name', '{notary_name}', 'Gimena Bustillo'],
    ['Notary Commission #', '{notary_commission_number}', 'GG320330'],
    ['Notary Commission Exp.', '{notary_commission_expiration}', '2023-04-28'],
    ['Second Leasee', '{second_leasee}', 'Richard Johnson'],
    ['Third Leasee', '{third_leasee}', 'Roy Johnson'],
    ['Judicial Circuis', '{judicial_circuit}', 'ELEVENTH'],
    ['County', '{county}', 'MIAMI-DADE'],
    ['DBA', '{dba}', 'Royalton on the Green'],
    ['Clerk of Courts', '{clerk_of_courts}', 'HARVEY RUIN'],
    ['First day of the month', '{first_of_month}', '4/1/2020'],
    ['Todays date', '{todays_date}', '3/20/2020'],
    ['Signs 3 Day', '{signs_3day}', 'Ricardo Cuevas'],
    ['Three Day Month', '{three_day_month}', 'January'],
    ['Three Day Expiration', '{three_day_expiration_date}', 'January 1, 2001'],
    ['Stipulation Signed Date', '{stipulation_signed_date}', 'January 1, 2001'],
    ['Initail Payment', '{initial_payment}', '1500.40'],
    ['Balance', '{balance}', '22540.56'],
    ['Court Address', '{court_address}', 'Dade Courthouse  73 West Flagler Street Miami FL 33130'],
    ['Property Address', '{property_address}', '2750 nw 56th ave'],
    ['Property City State Zip', '{property_city_state_zip}', 'lauderhill fl 33178'],
    ['Stip Payments (dynamic)', '{payment_1}', '1000'],
    ['Stip Payment Dates (dynamic)', '{payment_1_date}', 'January 1, 2001'],
    ['Legal Name', '{legal_name}', 'Village Shopping Center Trust, LLC']

];
export default tags;
